import React, { useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"

import "./OutputTabs.scss"


function OutputTabs ({classNameProp, tabs = [], getTab}) {

    const [tableId, setTable] = useState(1)

    const toggle = (id) => {
      setTable(id)
      getTab(id)
    }

    return (
      <div className={`OutputTabs ${classNameProp}`}>
        <ul>
          {tabs.map(tab => (
            <li key={tab.id} className={tableId === tab.id ? "Tab active" : "Tab"} onClick={() => {toggle(tab.id)}}>
              {tab.name}
            </li>
          ))}
        </ul>
      </div>
    )
}

export default OutputTabs